import React, { Component } from "react"
import axios from 'axios'
import FeedbackWidget from "../Widgets/Feedback/FeedbackWidgetOLD";
import FeedbackMessages from "../Feedback/FeedbackMessageDisplay"
import {createFeedback,fetchAllFeedback,deleteThread,deleteThreadParent} from "../../../util/feedback_util"
import {ManageUsersIconWhite,deleteInstructionIconWhite} from "../../Templates/icons"
import SimpleModal from "./modal"
import FormRow from '../../Templates/FormRow'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare,faFileZipper,faTrashCan } from '@fortawesome/free-regular-svg-icons'
import { getDateLocal } from "../../Templates/functions"

class Feedback extends Component {
    signal = axios.CancelToken.source()
    state = {
        isLoading: true,
        testData : [],
        key :Date.now(),

          selectedThreadId:null,
          selectedThreadIndex : 0,
          selectedParentId:null,
          selectedParentIndex : 0,
          CurrentFeedback: [],
          testUser: this.props.currentUser,
          UserID: this.props.currentUserId,
          showModal:false,
          modalMode:"threads"
    }

    componentDidMount = () => {
      console.log(this.props)
        this.loadData()
    }

    componentWillUnmount = () => {
        this.signal.cancel('Api is being canceled');
    }
    
    loadData = () => {
        fetchAllFeedback(this.signal.token).then((res) => {
           if (this.state.selectedParentId != null){
            const parentIndex = res.findIndex(parent => parent.wip_id === this.state.selectedParentId)
            const threadIndex = res[parentIndex].threads.findIndex(thread => thread.ThreadID === this.state.selectedThreadId)
            this.setState({
                isLoading: false,
                testData: res,
                selectedParentIndex: parentIndex,
                selectedThreadIndex: threadIndex
            })
           }

            this.setState({
                isLoading: false,
                testData: res
            })
        })
    }

    createFeedbackThreadList = () => {
      const feedbackData = this.state.testData;
      
      return (
        
        <ul style={{listStyleType: 'none',padding: "0",margin: "0",height:"calc(100% - 120px)"}}>    
          {feedbackData.map((parent,parent_index) => (
            <li key={parent._id} style={{ margin: '10px 0', padding: '5px'  }}> 
              <div title={parent.wip_name} style={{fontSize:"18px",padding: '5px',display:'flex',backgroundColor: '#f0f0f0',borderRadius: '7px',overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace: 'nowrap'}}>
                 <p style={{flexDirection:"row",display:"flex",marginTop:"8px"}}>Work Instruction: {parent.wip_name}</p>
                             
                <div className="feedback-actions">
                  {/* <button 
                    className="action-button archive-button"
                    //onClick={() => handleArchive(feedback._id)}
                    title="Archive"
                  >
                    <FontAwesomeIcon icon={faFileZipper} />
                  </button> */}
                  <button 
                    className="action-button delete-button"
                    onClick={() => {
                      if(window.confirm("Deleting this thread parent will delete all messages in this thread. Are you sure you want to continue?")){

                      deleteThreadParent(parent.wip_id).then(()=>{
                        if(parent.wip_id == this.state.selectedParentId){
                          this.setState({selectedParentId:null,selectedThreadId:null,selectedParentIndex:0,selectedThreadIndex:0,CurrentFeedback:[]})
                        }
                        this.loadData()
                      })
                    }}
                  }
                    title="Delete"
                  >
                    {/* <FontAwesomeIcon icon={faTrashCan} /> */}
                    {deleteInstructionIconWhite}
                  </button>
                </div>
              </div>
              <ul style={{  listStyleType: 'none',padding: '0 0 0 15px',margin: '5px 0' }}>
                {parent.threads.map((thread, index) => (
                  <li 
                    key={thread.ThreadID}
                    onClick={() => this.displayFeedbackMessages(thread,parent.wip_id, index,parent_index)}

                    style={{fontSize:"16px",width: '96%',cursor: 'pointer',padding: '5px',border: '1px solid #ccc', marginTop: '5px',
                      marginLeft: '2.6%',overflow: 'hidden',textOverflow: 'ellipsis',whiteSpace: 'nowrap',

                      backgroundColor: this.state.selectedThreadId === thread.ThreadID ? '#839BCF' : 'transparent',
                      color: this.state.selectedThreadId === thread.ThreadID ? 'white' : 'black',borderRadius:"7px", display:"flex", flexDirection:"row"}}   title={thread.ThreadName}
                  >
                    <p style={{flexDirection:"row",display:"flex",marginTop:"8px"}}>{thread.ThreadName}</p>

                                
                    <div className="feedback-actions">
                      {/* <button 
                        className="action-button archive-button"
                        //onClick={() => handleArchive(feedback._id)}
                        title="Archive"
                      >
                        <FontAwesomeIcon icon={faFileZipper} />
                      </button> */}
                      <button 
                        className="action-button delete-button"
                        onClick={() => {
                          if(window.confirm("Are you sure you want to delete this thread?")){
                          deleteThread({thread:thread.ThreadID,parent:parent.wip_id}).then(()=>{
                            if(thread.ThreadID == this.state.selectedThreadId){
                              this.setState({selectedThreadId:null,selectedParentId:null,selectedThreadIndex:0,selectedParentIndex:0,CurrentFeedback:[]})
                            }
                            this.loadData()
                          })
                        }
                        }}    
                        title="Delete"
                      >
                        {/* <FontAwesomeIcon icon={faTrashCan} /> */}
                        {deleteInstructionIconWhite}
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      );
    }
     
      
     displayFeedbackMessages=(feedbackArray,wip_id,index,parent_index) => {
      let newKey = Date().toLocaleString()
        this.setState({selectedThreadId:feedbackArray.ThreadID,selectedThreadIndex:index,selectedParentId:wip_id,
                       selectedParentIndex:parent_index,CurrentFeedback:this.state.testData[parent_index].threads[index].Feedback,key:newKey})
        console.log('Displaying feedback messages:', feedbackArray);
      }

     uuidv4Rand=()=> {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }

     convertUTCDateToLocalDate(date) {
      var newDate = new Date(date);
      newDate.setMinutes(Date.getMinutes() - Date.getTimezoneOffset());
        return date;
    }



     addMessageToThread =(message,media)=>{


        let newMessage = {
            message: message,
            username: this.props.currentUser,
            UserID : this.props.currentUserId,
            wip_name: this.state.testData[this.state.selectedParentIndex].wip_name,
            WIPID: this.state.testData[this.state.selectedParentIndex].threads[this.state.selectedThreadIndex].WIPID,
            ThreadID: this.state.selectedThreadId,
            ThreadName: this.state.testData[this.state.selectedParentIndex].threads[this.state.selectedThreadIndex].ThreadName,
            Attachments: [],
            FeedbackThread : this.state.selectedThreadId,
            date: getDateLocal(),
            //__id: this.uuidv4Rand(),
        }
        let tempAttachments = []
        if(media){
          
          media.forEach(element => {
            let attachment = {
              message_id: this.uuidv4Rand(),
              thread_id: this.state.selectedThreadId,
              path: element.originalname,
              _id: this.uuidv4Rand(),         
            }
            tempAttachments.push(attachment)
            newMessage.Attachments.push(element)
          });
          
        }

        createFeedback(newMessage,media).then((res)=>{
          const threads = [...this.state.testData]
          newMessage._id = res.data._id
          threads[this.state.selectedParentIndex].threads[this.state.selectedThreadIndex].Feedback.push(newMessage)
          
          let newKey = Date().toLocaleString()
          this.setState({testData:threads,CurrentFeedback:threads[this.state.selectedParentIndex].threads[this.state.selectedThreadIndex].Feedback,key:newKey},()=>{
              console.log(this.state.testData)
          })
        })

     }

     createNewThread = (mode) => {
        this.setState({showModal:true,modalMode:mode})
     }

    render() {
       return <div id="feedback-page" className="flex-column max-width" >
        {this.state.showModal ?
             <SimpleModal closeModal={()=>this.setState({showModal:false},()=>this.loadData())} 
                          loadData={()=>this.loadData()} 
                          removeModel={()=>this.setState({showModal:false})} 
                          fileTitle={""} 
                          modalMode={this.state.modalMode} 
                          currentUser={this.props.currentUser} 
                          currentUserId={this.props.currentUserId} 
                          currentUserRole={this.props.currentUserRole} 
                          modelName={""} 
                          modelId={""} 
                          approveModel={()=>{}}
                          thread={this.state.modalMode !== "threads"  ? this.state.testData[this.state.selectedParentIndex].threads[this.state.selectedThreadIndex] : null}
                          modalTitle={this.state.modalMode === "threads" ? "Create New Thread" : "Feedback User Management"} 
                          /> : null}
                          
        
            <div id="feedback-widget-container" className="feed-item-wide-feedback max-height " >
               <div className="work-instruction-page max-width" style={{ height: "100%", display:"flex", flexDirection:"row", overflowY:"hidden",justifyContent:"space-evenly"}}>

                <div  className="left-column FeedbackPageSections work-instructions-page-window max-width rel shadow" style={{width:"48%"}}>

                    <div id="wi-page-container-header" className="flex-apart" style={{ padding: ".6em 1em"}}>
                        <h3 className="flex-centered">Feedback Threads</h3>            
                    </div>
                       {this.createFeedbackThreadList()}
                      <div id="feedback-thread-container" onClick={()=>this.createNewThread('threads')} className="clickable">
                        <div style={{marginRight:"auto", marginLeft:"auto",color:"white", display:"flex",bottom:"5px"}}>
                          <p style={{ marginRight: ".625em", fontSize:"18px" ,color:"white"}}>New Thread</p> 
                          <FontAwesomeIcon icon={faPenToSquare}/>
                        </div>
                      </div>

                </div> 
                {/* /////////////////////////////////////////////////////// */}
                {/* <div style={{width:"6px"}}></div> */}
                {/* /////////////////////////////////////////////////////// */}  

                <div  className=" right-column FeedbackPageSections work-instructions-page-window max-width rel shadow " style={{width:"48%"}}>

                    <div id="wi-page-container-header" className="flex-apart" style={{ padding: ".6em 1em"}}>
                        <h3 className="flex-centered">Feedback</h3> 
                        {this.state.selectedThreadId != null ?<div id="wi-summary-action" style={{height:"20px",width:'82px'}} className="flex-column-centered clickable" onClick={()=>this.createNewThread('users')}>
                            {ManageUsersIconWhite}
                        </div> : null}           
                    </div>
                    <div className="instruction-content" style={{height:"calc(100% - 120px)", textAlign:"center"}}>
                                           
                           { this.state.selectedThreadId == null?
                            <p style={{marginTop:'50%'}}>Please Select a thread</p> :
                            <FeedbackMessages
                                key={this.state.key}
                                feedbackObjects = {this.state.CurrentFeedback}
                                currentUser = {this.props.currentUser}
                                currentUserId = {this.props.currentUserId}
                                addMessageToThread={this.addMessageToThread}  
                                threadId={this.state.selectedThreadId}
                            />}
                        
                       
                    </div>
                </div>
</div>
            </div>
        </div>
    }
}

export default Feedback;
